module.exports = __webpack_public_path__ + "static/img/appointment02.5320646a.png";